export default function Footer() {
  return (
    <footer id="footer" className="relative bg-background-900">
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-primary-500/40 to-transparent"></div>

      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="flex-1 max-w-sm">
              <div className="flex items-center gap-2.5 mb-4">
                <span className="w-[34px] h-[34px] flex items-center justify-center rounded-lg bg-primary-500 text-background-950 font-bold text-sm">
                  <i className="ri-movie-2-line text-base"></i>
                </span>
                <span className="font-heading text-xl text-foreground-50 font-bold tracking-wide">
                  爱看影院
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                爱看影院致力于为广大影迷提供免费电影大全与免费电视剧全集，海量高清影视资源在线观看不卡顿。每日更新热播电影、电视剧、综艺、动漫，是您追剧观影的首选平台。
              </p>
            </div>

            <div className="flex flex-wrap gap-10 lg:gap-16">
              <div>
                <h4 className="font-heading text-base text-foreground-200 mb-4">快速导航</h4>
                <ul className="space-y-2.5">
                  {[
                    { label: '精选推荐', href: '#cards' },
                    { label: '热门话题', href: '#topics' },
                    { label: '分类索引', href: '#index' },
                    { label: '热播榜单', href: '#ranking' },
                    { label: '最新动态', href: '#updates' },
                  ].map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        onClick={(e) => {
                          e.preventDefault();
                          document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                        }}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="font-heading text-base text-foreground-200 mb-4">帮助中心</h4>
                <ul className="space-y-2.5">
                  {[
                    { label: '常见问题', href: '#faq' },
                    { label: '用户口碑', href: '#comments' },
                    { label: '关于我们', href: '#about' },
                    { label: '联系我们', href: '#contact' },
                    { label: '平台优势', href: '#features' },
                  ].map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        onClick={(e) => {
                          e.preventDefault();
                          document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                        }}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="font-heading text-base text-foreground-200 mb-4">合作伙伴</h4>
                <p className="text-sm text-foreground-500 leading-relaxed max-w-[180px]">
                  诚邀优质影视内容方、广告主及媒体平台携手合作，共创共赢。
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 爱看影院 — 免费电影大全与免费电视剧全集 | 影视大全免费在线观看不卡顿
            </p>
            <div className="flex items-center gap-5">
              <span className="text-xs text-foreground-600">每日更新，追剧无忧</span>
              <span className="text-xs text-foreground-600">高清流畅，永久免费</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}